export default __webpack_public_path__ + "static/assets/5e695f7b81f4bd606ea4ae608e96f040.png";